import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = () => ({
  root: {},
  label: {},
});

const sizeMap = {
  sm: 'h6',
  md: 'h3',
};

const TabLabel = ({
  className, classes, label, size, textColor,
}) => {
  return (
    <Box className={classNames(classes.root, className)}>
      <Typography
        className={classes.label}
        variant={sizeMap[size]}
        weight={'bold'}
        color={textColor}
      >
        {label}
      </Typography>
    </Box>
  );
};

TabLabel.defaultProps = {
  className: '',
  size: 'md',
  textColor: 'primary',
};

TabLabel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  textColor: PropTypes.string,
};

export default withStyles(styles)(TabLabel);
